import React, { useState } from "react";
import cambioEstadoService from "../../services/cambioEstadoService";
import { obtenerSiguienteEstadoART } from "../../services/art/artEstadoService";
import { toast } from "react-toastify";
import GavelIcon from '@mui/icons-material/Gavel';
import DescriptionIcon from '@mui/icons-material/Description';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';

function GestorJudicializado({ tramite, onAvanzar }) {
    const [cargando, setCargando] = useState(false);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const [observaciones, setObservaciones] = useState("");

    const handleConfirmar = async () => {
        setCargando(true);
        try {
            const siguienteEstado = await obtenerSiguienteEstadoART(tramite.nombreEstadoActual, "Finalizado");

            if (!siguienteEstado) {
                toast.error("No se pudo obtener el estado destino: Finalizado.");
                setCargando(false);
                return;
            }

            const comentarioFinal = observaciones.trim() ?
                `Fin de seguimiento en la aplicación. Trámite judicializado.\nObservaciones: ${observaciones}` :
                `Fin de seguimiento en la aplicación. Trámite judicializado.`;

            await cambioEstadoService.cambiarEstado(tramite.idTramite, {
                idEstado: siguienteEstado.id || siguienteEstado.idEstado,
                comentario: comentarioFinal
            });

            toast.success('Trámite finalizado correctamente');
            onAvanzar();
        } catch (error) {
            console.error('Error:', error);
            toast.error("Error al finalizar: " + (error.response?.data?.message || error.message));
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            {/* Header con Ícono y Título */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-dark mb-0">
                    <GavelIcon className="me-2" style={{ fontSize: '1.5rem' }} />
                    Judicializado
                </h4>
                <span className="badge bg-primary rounded-pill px-3 py-2">
                    <GavelIcon fontSize="small" className="me-1" />
                    Poder Judicial
                </span>
            </div>

            {/* Alert informativo */}
            <div className="alert alert-danger border-0 rounded-3">
                <strong>Información:</strong>
                <p className="mb-0 mt-1">
                    El trámite se encuentra judicializado. El seguimiento continúa en el Poder Judicial.
                    Esta es la última acción dentro de la aplicación.
                </p>
            </div>

            {!mostrarFormulario ? (
                <>
                    {/* --- ACCIONES DE SALIDA --- */}
                    <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                        <button
                            className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarFormulario(true)}
                            disabled={cargando}
                        >
                            <SendIcon fontSize="small" />
                            Finalizar Trámite
                        </button>
                    </div>
                </>
            ) : (
                <>
                    {/* --- SECCIÓN DE OBSERVACIONES --- */}
                    <div className="mt-4 p-3 bg-light rounded-3 border">
                        <h6 className="fw-semibold text-primary mb-3">
                            <DescriptionIcon fontSize="small" className="me-2 mb-1" />
                            Observaciones Generales
                        </h6>
                        <textarea
                            className="form-control shadow-sm"
                            rows="4"
                            placeholder="Agregue cualquier comentario o observación final sobre el trámite..."
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                            maxLength="500"
                            disabled={cargando}
                            style={{ borderRadius: '0.5rem',
                                border: '1px solid #e0e0e0',
                                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", 
                                lineHeight: '1.5' }}
                        />
                        <small className="text-muted mt-2 d-block">
                            {observaciones.length}/500 caracteres - Estos comentarios se guardarán en el historial.
                        </small>
                    </div>

                    {/* --- ACCIONES DE CONFIRMACIÓN --- */}
                    <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                        <button
                            className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => {
                                setMostrarFormulario(false);
                                setObservaciones("");
                            }}
                            disabled={cargando}
                        >
                            <CancelIcon fontSize="small" />
                            Cancelar
                        </button>
                        <button
                            className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={handleConfirmar}
                            disabled={cargando}
                        >
                            {cargando ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Finalizando...
                                </>
                            ) : (
                                <>
                                    <SendIcon fontSize="small" />
                                    Confirmar Fin de Trámite
                                </>
                            )}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}

export default GestorJudicializado;

